import client from '../request'

const getAll = `/subscriptions`

const get = (id) => {
  return `/subscriptions/${id}`
}

const create = (data) => {
  return client.post('/subscriptions', data)
}

const getActivity = (id) => {
  return `/subscriptions/${id}/activity`
}

const addActivity = (id, data) => {
  return client.post(`/subscriptions/${id}/activity/add`, data)
}

const reorderActivity = (id, data) => {
  return client.post(`/subscriptions/${id}/activity/reorder`, data)
}

const removeActivity = (id, subscriptionActivityId) => {
  return client.delete(`/subscriptions/${id}/activity/${subscriptionActivityId}`)
}

const update = (id, data) => {
  return client.put(`/subscriptions/${id}`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/subscriptions/${id}`)
}

const SubscriptionService = {
  getAll,
  get,
  create,
  getActivity,
  reorderActivity,
  addActivity,
  removeActivity,
  update,
  toRow,
  remove,
  toPaginate
}

export default SubscriptionService
